import { AlertCallout } from "@/components/ui/alert-callout";
import { Button } from "@/components/ui/button";

interface DatabaseErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

/** Salt error banner for database and record-loading failures. */
export function DatabaseErrorState({
  message = "Unable to connect to the database. This may be a temporary issue.",
  onRetry,
}: DatabaseErrorStateProps) {
  return (
    <AlertCallout title="Connection Error" variant="error">
      <p>{message}</p>
      {onRetry && (
        <div style={{ marginTop: "var(--salt-spacing-100)" }}>
          <Button onClick={onRetry} type="button" variant="outline">
            Retry
          </Button>
        </div>
      )}
    </AlertCallout>
  );
}
